// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader-bkg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(255, 255, 255, 0.8); 
    /* background: #ffffff; */
    z-index: 3000;
}
.loader-container {
    position: relative;
    transform: scale(0.3); /* Scale down to 30% of the original size */
    transform-origin: center; /* Ensure scaling happens from the center */
    text-align: center; 
    height: 90%;
}
.loader {
    width: 80px;
    height: 80px;
}
.loader circle {
    fill: transparent;
    stroke: #e1261c;
    stroke-width: 8;                        /* width x .1 */
    stroke-dasharray: 251.33;               /* width x pi */
    transform-origin: 40px 40px 0;          /* width x .5, width x .5, 0 */
    animation: loader 2s linear infinite;
}
@keyframes loader {
    0% {
        transform: rotate(-90deg);
        stroke-dashoffset: 62.83;        /* .25 x pi x width */
    }
    16.67% {
        transform: rotate(27deg);
        stroke-dashoffset: 50.27;        /* .20 x pi x width */
    }
    33.33% {
        transform: rotate(153deg);
        stroke-dashoffset: 75.40;        /* .30 x pi x width */
    }
    58.33% {
        transform: rotate(320deg);
        stroke-dashoffset: 138.23;       /* .55 x pi x width */
    }
    66.67% {
        transform: rotate(385deg);
        stroke-dashoffset: 138.23;       /* .55 x pi x width */
    }
    83.33% {
        transform: rotate(516deg);
        stroke-dashoffset: 113.10;       /* .45 x pi x width */
    }
    100% {
        transform: rotate(630deg);
        stroke-dashoffset: 62.83;        /* .25 x pi x width */
    }
}`, "",{"version":3,"sources":["webpack://./projects/lossreporting-library/src/lib/shared/loading-indicator/loading-indicator.component.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,oCAAoC;IACpC,yBAAyB;IACzB,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,qBAAqB,EAAE,2CAA2C;IAClE,wBAAwB,EAAE,2CAA2C;IACrE,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,eAAe,yBAAyB,eAAe;IACvD,wBAAwB,gBAAgB,eAAe;IACvD,6BAA6B,WAAW,8BAA8B;IACtE,oCAAoC;AACxC;AACA;IACI;QACI,yBAAyB;QACzB,wBAAwB,SAAS,qBAAqB;IAC1D;IACA;QACI,wBAAwB;QACxB,wBAAwB,SAAS,qBAAqB;IAC1D;IACA;QACI,yBAAyB;QACzB,wBAAwB,SAAS,qBAAqB;IAC1D;IACA;QACI,yBAAyB;QACzB,yBAAyB,QAAQ,qBAAqB;IAC1D;IACA;QACI,yBAAyB;QACzB,yBAAyB,QAAQ,qBAAqB;IAC1D;IACA;QACI,yBAAyB;QACzB,yBAAyB,QAAQ,qBAAqB;IAC1D;IACA;QACI,yBAAyB;QACzB,wBAAwB,SAAS,qBAAqB;IAC1D;AACJ","sourcesContent":[".loader-bkg {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background: rgba(255, 255, 255, 0.8); \n    /* background: #ffffff; */\n    z-index: 3000;\n}\n.loader-container {\n    position: relative;\n    transform: scale(0.3); /* Scale down to 30% of the original size */\n    transform-origin: center; /* Ensure scaling happens from the center */\n    text-align: center; \n    height: 90%;\n}\n.loader {\n    width: 80px;\n    height: 80px;\n}\n.loader circle {\n    fill: transparent;\n    stroke: #e1261c;\n    stroke-width: 8;                        /* width x .1 */\n    stroke-dasharray: 251.33;               /* width x pi */\n    transform-origin: 40px 40px 0;          /* width x .5, width x .5, 0 */\n    animation: loader 2s linear infinite;\n}\n@keyframes loader {\n    0% {\n        transform: rotate(-90deg);\n        stroke-dashoffset: 62.83;        /* .25 x pi x width */\n    }\n    16.67% {\n        transform: rotate(27deg);\n        stroke-dashoffset: 50.27;        /* .20 x pi x width */\n    }\n    33.33% {\n        transform: rotate(153deg);\n        stroke-dashoffset: 75.40;        /* .30 x pi x width */\n    }\n    58.33% {\n        transform: rotate(320deg);\n        stroke-dashoffset: 138.23;       /* .55 x pi x width */\n    }\n    66.67% {\n        transform: rotate(385deg);\n        stroke-dashoffset: 138.23;       /* .55 x pi x width */\n    }\n    83.33% {\n        transform: rotate(516deg);\n        stroke-dashoffset: 113.10;       /* .45 x pi x width */\n    }\n    100% {\n        transform: rotate(630deg);\n        stroke-dashoffset: 62.83;        /* .25 x pi x width */\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
